module.exports = __webpack_public_path__ + "static/media/icon_arrow.5d77d481.svg";